import { Box, FormLabel, Skeleton, Typography } from "@mui/material";
import FeedRoundedIcon from '@mui/icons-material/FeedRounded';
import TooltipNumber from "../../new/basicData/TooltipNumber";
import TooltipInvoiceType from "../../new/basicData/TooltipInvoiceType";

const InvoiceShowBasicData = ({ invoice }) => {
    const WithSkeleton = ({ loading, children }) =>
        loading ? <Skeleton variant="text" width={80} /> : children;

    const invoiceTypeMap = {
        has_work: 'Com vínculo',
        without_work: 'Sem vínculo',
    };

    const invoiceNumber = invoice?.invoice_number || '';
    const customerName = invoice?.customer?.name || '';
    const invoiceType = invoice?.invoice_type || '';

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <FeedRoundedIcon sx={{ color: 'primary.main' }} />
                <Typography variant='h5' sx={{ color: 'primary.main' }}>Dados Gerais</Typography>
            </Box>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr",
                    gap: 2,
                }}
            >
                <Box>
                    <TooltipNumber />
                    <WithSkeleton loading={!invoice}>
                        <Typography>{invoiceNumber}</Typography>
                    </WithSkeleton>
                </Box>
                <Box>
                    <FormLabel sx={{ color: 'text.primary' }}><b>Cliente</b></FormLabel>
                    <WithSkeleton loading={!invoice}>
                        <Typography>{customerName}</Typography>
                    </WithSkeleton>
                </Box>
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <FormLabel sx={{ color: 'text.primary' }}><b>Tipo de fatura</b></FormLabel>
                        <TooltipInvoiceType />
                    </Box>
                    <WithSkeleton loading={!invoice}>
                        <Typography>{invoiceTypeMap[invoiceType]}</Typography>
                    </WithSkeleton>
                </Box >
            </Box >
        </Box >
    )
}

export default InvoiceShowBasicData;